import { homeFaqs } from "@/mocks/faq";
import { SectionHeading } from "@/components/base/Shared";
import Accordion from "@/components/feature/Accordion";

export default function FaqSection() {
  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl mx-auto">
          <SectionHeading
            eyebrow="FAQ"
            title="关于网红黑曝发酵与传播追踪的常见问题"
            desc="下面这些问题来自读者反复提到的疑问，也是理解本站数据口径的入口。"
            align="center"
          />
          <Accordion items={homeFaqs} />
        </div>
      </div>
    </section>
  );
}